import type { EventData, HomePageContent, SiteSettings } from "@/services/sanity/types";

export const fallbackSiteSettings: SiteSettings = {
    address: "Freemans Bay Community Centre\n52 Hepburn Street, Freemans Bay, Auckland 1011",
    contactEmail: "darvodelsky@gmail.com",
    adminUrl: "https://bejzbcu2.sanity.studio",
};

export const fallbackEvents: EventData[] = [
    {
        title: "Sunday Worship Gathering",
        description: "Join us for Sunday worship, communion, and fellowship at Freemans Bay Community Centre.",
        date: "2026-03-15T10:00:00+13:00",
        endDate: "2026-03-15T12:00:00+13:00",
        location: "Freemans Bay Community Centre",
        address: "52 Hepburn Street, Freemans Bay, Auckland 1011",
        googleMapsLink: "https://www.google.com/maps/search/?api=1&query=52+Hepburn+Street+Auckland",
        isUpcoming: true,
    },
    {
        title: "Midweek Bible Study",
        description: "Midweek small group Bible study and fellowship hosted across Auckland.",
        date: "2026-03-18T19:00:00+13:00",
        endDate: "2026-03-18T21:00:00+13:00",
        location: "Central Auckland",
        address: "Contact us for this week's host home details",
        googleMapsLink: "",
        isUpcoming: true,
    },
];

export const fallbackHomePageContent: HomePageContent = {
    homepage: {
        heroHeading: "Welcome to Auckland Church",
        heroSubheading: "A community of believers striving to honour Christ through our love for one another and the world around us.",
        heroHeadingMi: "Nau Mai ki te Hāhi o Tāmaki Makaurau",
        heroSubheadingMi: "He hapori whakapono e ngākau nui ana ki te whakamana i a Karaiti mā tō mātou aroha ki ētahi atu me te ao whānui.",
        whatToExpect: {
            heading: "What to Expect",
            description: "Visiting a new church can be intimidating. Here is what you will find when you walk through our doors.",
            headingMi: "He aha tāu e tūmanako ana",
            descriptionMi: "He mea whakamataku pea te haere ki tētahi hāhi hōu. Anei ngā mea ka kitea e koe i a koe e tū ana i raro i ō mātou tatau.",
            cards: [
                {
                    title: "Casual Atmosphere",
                    description: "Come as you are. We care about you, not what you are wearing.",
                    icon: "smile",
                    titleMi: "Āhuatanga Māmā",
                    descriptionMi: "Haere mai, ko koe tonu. Ko tōu tangata te mea nui ki a mātou, ehara i ō kākahu.",
                },
                {
                    title: "Kids Program",
                    description: "Safe, fun, and faith-filled programs for children of all ages.",
                    icon: "baby",
                    titleMi: "Hōtaka Tamariki",
                    descriptionMi: "Ngā hōtaka haumaru, ngohengohe, whakapono hoki mō ngā tamariki o ngā pakiaka katoa.",
                },
                {
                    title: "Coffee and Connection",
                    description: "Stick around after the service for tea, coffee, and a chat.",
                    icon: "coffee",
                    titleMi: "Kawhe me te Hononga",
                    descriptionMi: "Nohoia tonu i muri i te karakia mō te tī, kawhe, me te kōrero.",
                },
            ],
        },
    },
    series: {
        title: "The Minor Prophets",
        description: "Join us as we journey through the Minor Prophets, discovering God's heart for justice, mercy, and faithfulness in a broken world.",
    },
    events: fallbackEvents,
};
